import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const KnowYourCustomerVerificationButton = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();

  const handleOnClick = async () => {
    await loadPageContentLink(resource.relationship(fr.relationships.devOnlyStartKnowYourCustomerVerification.name).link('related'));
  };

  return (
    <FDBox>
      <FDPrimaryActionButton
        onClick={handleOnClick}
        label={resource.relationship(fr.relationships.devOnlyStartKnowYourCustomerVerification.name).meta('prompt')}
      />
    </FDBox>
  );
};

KnowYourCustomerVerificationButton.defaultProps = {
};

KnowYourCustomerVerificationButton.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default KnowYourCustomerVerificationButton;
